
export const getBasicSavingsAmts = (savingsInfo) => {
    const savingsArr = savingsInfo.savingsArr;
    let beginBalance = 0;
    let totalMonthlyAmt = 0;
    
    for (let i=0; i<savingsArr.length; i++){
        const monthlySavingsAmt = +savingsArr[i].monthlyDepositAmt;
        let accountBalance = +savingsArr[i].savingTotals.totalDeposit +
             savingsArr[i].savingTotals.totalInterest - savingsArr[i].savingTotals.totalTransferAmt;
        beginBalance += accountBalance;
        totalMonthlyAmt += monthlySavingsAmt;
    }
    const returnObj = {beginBalance: beginBalance, monthlySavingsAmt: totalMonthlyAmt}
    return returnObj;
}
export default getBasicSavingsAmts;